import React from 'react';
export function Gallery() {
  const projects = [{
    type: 'Complete Roof Replacement',
    location: 'Austin, TX',
    gradient: 'from-slate-700 to-slate-900',
    image: 'https://cdn.magicpatterns.com/uploads/rQAdcCZbZoeHzum6DBYV9R/shingle-roof-min-1000x640.jpg'
  }, {
    type: 'Storm Damage Repair',
    location: 'Round Rock, TX',
    gradient: 'from-slate-800 to-slate-950',
    image: 'https://cdn.magicpatterns.com/uploads/b7mUTa35Qie8DwVoHMyWJW/Residential-roofing-Raleigh-NC-2.jpg'
  }, {
    type: 'Commercial Flat Roof',
    location: 'Cedar Park, TX',
    gradient: 'from-slate-600 to-slate-800',
    image: 'https://cdn.magicpatterns.com/uploads/aHxs1jqU6HyQiM8ZxMxXuK/Commercial_Flat_Repair.jpg'
  }, {
    type: 'Shingle Upgrade',
    location: 'Georgetown, TX',
    gradient: 'from-slate-800 to-slate-900',
    image: 'https://cdn.magicpatterns.com/uploads/uB1JEAqtQ5uodNxWLxDU9r/Shingle_Upgrade.webp'
  }, {
    type: 'Emergency Leak Repair',
    location: 'Pflugerville, TX',
    gradient: 'from-slate-700 to-slate-800',
    image: 'https://cdn.magicpatterns.com/uploads/76LkBqt6SttixRMEdzN8gQ/Emergency_Leak_Repair.jpg'
  }, {
    type: 'Historic Home Restoration',
    location: 'Lakeway, TX',
    gradient: 'from-slate-900 to-black',
    image: 'https://cdn.magicpatterns.com/uploads/4xzt3uzYxxMrTLfi7oLeNn/Historic_Home_Restoration.jpg'
  }];
  return <section className="py-16 md:py-24 bg-muted/30" data-id="element-156">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-157">
        <div className="text-center mb-16" data-id="element-158">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4" data-id="element-159">
            Our Work Speaks for Itself
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto" data-id="element-160">
            Browse our recent projects and see the ProRoof difference.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-161">
          {projects.map((project, index) => <div key={index} className="group relative rounded-xl overflow-hidden aspect-video shadow-md cursor-pointer" data-id="element-162">
              {/* Image or Gradient Placeholder */}
              {project.image ? <img src={project.image} alt={project.type} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-163" /> : <div className={`absolute inset-0 bg-gradient-to-br ${project.gradient} transition-transform duration-500 group-hover:scale-105`} data-id="element-164">
                  <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSIvPjwvc3ZnPg==')] opacity-20" data-id="element-165"></div>
                </div>}

              {/* Overlay Content */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex flex-col justify-end p-6" data-id="element-166">
                <h3 className="text-white font-bold text-xl mb-1 translate-y-2 group-hover:translate-y-0 transition-transform" data-id="element-167">
                  {project.type}
                </h3>
                <p className="text-slate-300 text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-168">
                  {project.location}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}